import { render, staticRenderFns } from "./LedMassMessageView.vue?vue&type=template&id=5f2d9613&"
import script from "./LedMassMessageView.vue?vue&type=script&lang=js&"
export * from "./LedMassMessageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports